import { render } from "./SessionsAdded.vue?vue&type=template&id=6dcf7da4"
import script from "./SessionsAdded.vue?vue&type=script&lang=js"
export * from "./SessionsAdded.vue?vue&type=script&lang=js"

import "./SessionsAdded.vue?vue&type=style&index=0&id=6dcf7da4&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__